import { SUPPLIERS_TYPES_IDS } from '@wyz/utils';
import { SupplierTypeCodeName } from '~/common/types';

export const SUPPLIERS_TYPES_CODENAME_TO_ID: Record<
  SupplierTypeCodeName,
  number
> = {
  DISTRIBUTOR_PLATFORM: SUPPLIERS_TYPES_IDS.PLATFORM_DISTRIBUTOR,
  CENTRAL_STOCK: SUPPLIERS_TYPES_IDS.CENTRAL_STOCK,
  DISTRIBUTOR_WYZ: SUPPLIERS_TYPES_IDS.WYZ_DISTRIBUTOR,
  MANUFACTURER: SUPPLIERS_TYPES_IDS.MANUFACTURER,
  SPECIALIST: SUPPLIERS_TYPES_IDS.SPECIALIST,
  COMPLETE_WHEEL: SUPPLIERS_TYPES_IDS.COMPLETE_WHEEL,
};
